import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { EmployeeSessionProvider } from "@/store/EmployeeSessionContext";
import {
  EmployeeProtectedRoute,
  ManagerProtectedRoute,
} from "@/components/ProtectedRoute";
import { EmployeeLogin } from "@/pages/EmployeeLogin";
import { EmployeeShifts } from "@/pages/EmployeeShifts";
import { EmployeePayslip } from "@/pages/EmployeePayslip";
import { ManagerLogin } from "@/pages/ManagerLogin";
import { Dashboard } from "@/pages/Dashboard";
import { ScheduleReview } from "@/pages/ScheduleReview";
import { ManagerTopbar } from "@/components/ManagerTopbar";

export default function App() {
  return (
    <BrowserRouter>
      <EmployeeSessionProvider>
        <Routes>
          {/* Employee routes */}
          <Route path="/" element={<EmployeeLogin />} />
          <Route
            path="/shifts"
            element={
              <EmployeeProtectedRoute>
                <EmployeeShifts />
              </EmployeeProtectedRoute>
            }
          />
          <Route
            path="/payslip/:weekId/:phone"
            element={
              <EmployeeProtectedRoute>
                <EmployeePayslip />
              </EmployeeProtectedRoute>
            }
          />

          {/* Manager routes */}
          <Route path="/manager/login" element={<ManagerLogin />} />
          <Route
            path="/manager"
            element={
              <ManagerProtectedRoute>
                <div className="min-h-screen bg-body">
                  <ManagerTopbar />
                  <Dashboard />
                </div>
              </ManagerProtectedRoute>
            }
          />
          <Route
            path="/manager/week/:weekId"
            element={
              <ManagerProtectedRoute>
                <div className="min-h-screen bg-body">
                  <ManagerTopbar />
                  <ScheduleReview />
                </div>
              </ManagerProtectedRoute>
            }
          />
          <Route
            path="/manager/payslip/:weekId/:phone"
            element={
              <ManagerProtectedRoute>
                <div className="min-h-screen bg-body">
                  <ManagerTopbar />
                  <EmployeePayslip />
                </div>
              </ManagerProtectedRoute>
            }
          />

          {/* Default redirects */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </EmployeeSessionProvider>
    </BrowserRouter>
  );
}
